import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const platformLabels = { android: 'Android', ios: 'iOS', web: 'Web', unknown: 'Unknown' };
export const statuses = {
    draft: ['草稿', 'default'], scheduled: ['已预约', 'blue'], queued: ['待发送', 'processing'],
    sending: ['发送中', 'processing'], completed: ['已完成', 'success'],
    partial_failed: ['部分失败', 'warning'], failed: ['失败', 'error'], cancelled: ['已取消', 'default'],
};
export const deliveryStatuses = {
    accepted: ['FCM 已接受', 'success'], failed: ['永久失败', 'error'],
    retryable_failed: ['临时失败', 'warning'], retrying: ['等待重试', 'processing'],
    unknown: ['结果未知', 'warning'], skipped: ['已跳过', 'default'],
    pending: ['待发送', 'default'], sending: ['发送中', 'processing'],
};
export const countText = (value) => Number(value || 0).toLocaleString();
export const pushImageUrl = (value) => {
    if (typeof value !== 'string') return '';
    const image = value.trim();
    if (!image || image.length > 2048 || /\s/.test(image)) return '';
    try {
        const url = new URL(image);
        return url.protocol === 'https:' && url.hostname && !url.username && !url.password ? image : '';
    } catch { return ''; }
};
export const errorText = (error) => error?.message || '操作失败，请稍后重试。';
export const newRequestKey = () => {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    globalThis.crypto.getRandomValues(bytes);
    return Array.from(bytes, (v) => v.toString(16).padStart(2, '0')).join('');
};
export const translationUnresolved = (content) => !!content && !content.originalAccepted && (!!content.translationError || !!content.untranslatedTickers?.length);
export const reviewedCount = (campaign) => (campaign?.contents || []).filter((v) => (
    v.reviewed && !translationUnresolved(v) && Number(v.sourceRevision) === Number(campaign.sourceRevision)
)).length;
export const initialCampaign = (metadata) => ({
    id: '', name: '', businessType: 'POST', targetParams: {}, imageUrl: '', protectedTitleTickers: [], protectedBodyTickers: [], protectedTitleKeywords: [], protectedBodyKeywords: [],
    platforms: [...(metadata.platforms || ['android', 'ios'])],
    contents: (metadata.locales || []).map(({ code }) => ({
        locale: code, title: '', body: '', reviewed: false, sourceRevision: 0, manuallyEdited: false,
    })),
    revision: 0, sourceRevision: 0, status: 'draft', sendMode: 'immediate',
    timezone: 'Asia/Shanghai', ttlHours: 24,
});
export const formatPushTime = (value, zone) => {
    if (!value) return '尚未设置';
    try { return dayjs(value).tz(zone || 'UTC').format('YYYY-MM-DD HH:mm'); } catch { return value; }
};
export const buildSchedule = (mode, localValue, zone) => {
    if (mode === 'immediate') return { mode, timezone: zone };
    if (!localValue || !zone) throw new Error('请选择预约时间和时区。');
    const local = dayjs(localValue).format('YYYY-MM-DDTHH:mm');
    const scheduled = dayjs.tz(local, zone);
    if (scheduled.format('YYYY-MM-DDTHH:mm') !== local) throw new Error('该时间处于夏令时不存在的时段，请选择其他时间。');
    if (!scheduled.isAfter(dayjs().add(5, 'minute'))) throw new Error('预约时间必须晚于当前时间 5 分钟。');
    return { mode, timezone: zone, scheduledAt: scheduled.toISOString(), scheduledLocal: local };
};
export const confirmedForPublish = (campaign, locales) => (
    locales.every(({ code }) => campaign.contents?.some((v) => (
        v.locale === code && v.reviewed && !translationUnresolved(v) && Number(v.sourceRevision) === Number(campaign.sourceRevision)
        && v.title?.trim() && v.body?.trim()
    )))
);

export const deliveryErrorLabel = (code) => ({
    UNREGISTERED: '设备已失效或应用已卸载', QUOTA_EXCEEDED: '发送频率受限',
    UNAVAILABLE: '推送服务暂时不可用', INTERNAL: '推送服务内部错误',
    INVALID_ARGUMENT: '文案或参数不符合投递要求', SENDER_ID_MISMATCH: '当前发送项目与设备登记不匹配',
    THIRD_PARTY_AUTH_ERROR: '平台推送认证配置错误', AUTHENTICATION_ERROR: '推送服务认证失败',
    SEND_OUTCOME_UNKNOWN: '发送结果未知，请先检查设备，避免重复发送', TEST_INTERRUPTED: '测试过程被中断，发送结果未知',
    WORKER_INTERRUPTED: '发送过程被中断，结果未知', DEVICE_CHANGED_OR_DISABLED: '设备登记已变化或不可用',
    INVALID_OR_EXPIRED_PAYLOAD: '文案无效或通知已过期', TARGET_UNAVAILABLE: '目标内容已下架或不可用',
    EXPIRED: '通知有效期已结束', NO_ELIGIBLE_DEVICES: '没有符合条件的有效设备',
    INVALID_PLATFORM: '任务包含不支持的平台，请重新选择 Android、iOS、Web 或 Unknown',
})[code] || code || '—';
